import { Injectable } from '@angular/core';

@Injectable()
export class AppGlobals {
    readonly errorMessage: string = 'Something went wrong, Please try later!';    
    readonly userSuccess: string ='New user added successfully'
}
